// extracted by mini-css-extract-plugin
export default {"tutorials":"Tutorials_tutorials__rEnC9"};